(() => {
  const parseSize = (value) => {
    const match = String(value ?? '').trim().match(/^(\d{1,2})(?:[.,](\d{1,2}))?$/);
    if (!match) return null;
    const size = Number(match[1]) * 100 + Number((match[2] || '').padEnd(2, '0'));
    return size >= 1000 && size <= 3000 ? size : null;
  };

  const nearest = (variants, target, { sizeIndex = 0, options, matchedOnly = false } = {}) => {
    if (!Number.isSafeInteger(target) || target < 1000 || target > 3000 || !Array.isArray(variants)) return [];
    let distance = 31;
    let matches = [];
    variants.forEach((variant) => {
      if (variant.available !== true || variant.inStock !== true || !Array.isArray(variant.options)) return;
      if (matchedOnly && variant.matched !== true) return;
      if (options && (options.length !== variant.options.length || options.some((value, index) =>
        index !== sizeIndex && String(value) !== String(variant.options[index])
      ))) return;
      const size = parseSize(variant.options[sizeIndex]);
      if (size === null) return;
      const difference = Math.abs(size - target);
      if (difference > 30 || difference > distance) return;
      if (difference < distance) {
        distance = difference;
        matches = [];
      }
      matches.push(variant);
    });
    return matches.sort((a, b) => parseSize(a.options[sizeIndex]) - parseSize(b.options[sizeIndex]) || String(a.id).localeCompare(String(b.id)));
  };

  window.MonoreeRingSizing = Object.freeze({ parseSize, nearest });
})();
